// scheduling/components/OffOfficeFlag.jsx
// "This candidate is not in the on-site job's office" chip, for candidate LIST rows.
//
// Grid blocks have carried a `sched-offoffice-badge` for a while, but that class sets
// `pointer-events: none` so the block underneath keeps its drag handle and rich hover
// tooltip -- which also means the badge's own `title` never fires. On a block that is
// survivable (the rich tooltip now carries an Office row instead). In a plain list row
// there is no competing tooltip and nothing to drag, so these get a real `title`.
//
// WHY BADGE RATHER THAN FILTER
// ----------------------------
// Used on the lists that are deliberately NOT office-filtered:
//   * "Staff with WIP" / "Others who worked this job" -- these people have ALREADY
//     charged time to the job. Hiding them hides a fact, and if an out-of-office person
//     really did work an on-site engagement, that is worth seeing rather than erasing.
//   * the manual add-staff searches -- you are hand-picking someone by name, which is
//     an explicit decision the app should annotate, not overrule.
// The ranked suggestion lists DO filter, because there the app is the one proposing
// names and it should not propose a four-hour drive.

/**
 * @param {string} staffOffice     candidate's OfficeCode
 * @param {boolean} isOnSite       is the job flagged on-site?
 * @param {string} jobOfficeCode   the job's OfficeCode
 * @param {string} jobOffice       the job's full office name, for the tooltip
 * @param {string} staffName       for the tooltip
 */
export default function OffOfficeFlag({ staffOffice, isOnSite, jobOfficeCode, jobOffice, staffName, style }) {
  // Only meaningful on an on-site job with a known office, for a candidate whose own
  // office is known AND different. An unknown office is not the same as a mismatch --
  // claiming "off-office" for a staffer with no OfficeCode would be a guess.
  if (!isOnSite || !jobOfficeCode || !staffOffice) return null;
  if (staffOffice === jobOfficeCode) return null;

  return (
    <span
      className="sched-offoffice-badge sched-offoffice-badge--interactive"
      title={
        `On-site job in ${jobOffice || jobOfficeCode}. `
        + `${staffName || 'This staffer'} is based in ${staffOffice}, so they would have to travel. `
        + `You can still pick them — this list is not office-filtered.`
      }
      style={style}
    >
      &#128205; off-office
    </span>
  );
}
